export default "__VITE_ASSET__DCA1_DvZ__"